import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'exchange/components/list/ExchangeActions';

import { formatDate } from 'lib/util';
import { formatNumber } from 'accounting-js';

const ExchangeListRow = ({ exchange, company, permissions, t, handleToggle }) => {
  return (
    <tr>
      <td className="text-center">{exchange._fromCurrency}</td>
      <td className="text-center">{exchange._toCurrency}</td>
      <td className="text-center">{formatDate(exchange.date)}</td>
      <td className="text-right">{formatNumber(exchange.value, { precision: 4 })}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          exchange={exchange}
          company={company}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(ExchangeListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/ExchangeListRow.js